import * as Dialog from '@radix-ui/react-dialog';
import { Check } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { FeedbackConfirmationProps } from './FeedbackConfirmation.types';

export const FeedbackConfirmation = ({
  microcopy,
  className = '',
  open = true,
  onOpenChange,
}: FeedbackConfirmationProps) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-[60] bg-black/40 dark:bg-overlay" />
      <Dialog.Content
        className={c(
          'fixed left-1/2 top-1/2 z-[60] -translate-x-1/2 -translate-y-1/2',
          'flex min-h-[300px] w-8/12 flex-col rounded-lg bg-surface-raised text-center text-content focus-visible:outline-transparent md:h-4/6 md:w-8/12 md:max-w-2xl md:p-0',
          className
        )}
      >
        <div className="flex flex-1 flex-col items-center justify-center md:px-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-surface-muted text-center">
            <Check weight="bold" className="mx-auto" size={18} />
          </div>
          <Dialog.Title className="mb-5 mt-5 text-2xl font-semibold">
            {microcopy.title}
          </Dialog.Title>
          <Dialog.Description className="text-sm">
            {microcopy.subtitle}
          </Dialog.Description>
        </div>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
